import {observer} from "mobx-react";
import React, {useContext, useState} from "react";
import TableGeneric from "@dropDesk/presentation/components/tables/table_generic";
import HighLightWords from "@dropDesk/presentation/components/high_light_words";
import {displayDateToLocale} from "@dropDesk/utils/helpers/date_helper";
import {Button, ContainerAction} from "./styled";
import {MenuCollapsedContext} from "@dropDesk/presentation/routes/private_route";
import {ListPaginationEntity} from "@dropDesk/domain/entities/common/list_pagination.entity";
import {BackupData} from "@dropDesk/domain/entities/ticket/backup/backup_data";
import TagBackup from "@dropDesk/presentation/components/tag/tag_backup";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";

const TableBackup = observer(
    ({
         searchParam,
         loading,
         tableBackups,
         getDataFromPage,
         handleClickDownloadBackup
     }: {
        searchParam: string,
        loading: boolean,
        tableBackups: ListPaginationEntity<BackupData>,
        getDataFromPage: (page: number) => void,
        handleClickDownloadBackup: (backupData: BackupData) => void
    }) => {

        const collapsed = useContext(MenuCollapsedContext);
        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        const tableColumn = [

            {
                title: 'Atendimento inicial',
                ellipsis: true,
                dataIndex: 'startNumber',
                key: 'id',
                render: (text: string) => (
                    <HighLightWords
                        searchWords={searchParam}
                        textToHighlight={text}
                    />
                ),
            },
            {
                title: 'Atendimento final', ellipsis: true, dataIndex: 'endNumber', key: 'id', render: (text: string) => (
                    <HighLightWords
                        searchWords={searchParam}
                        textToHighlight={text}
                    />
                ),
            },
            {
                title: 'Status',
                dataIndex: 'status',
                render: (text: string, record: BackupData) => {
                    return (
                        <TagBackup
                            width={95}
                            status={record.status}
                            label={record.translateStatus}
                        />
                    )
                }
            },
            {
                title: 'Criado em', ellipsis: true, dataIndex: 'createdAt', key: 'id', render: (text: string) => (
                    <span>{displayDateToLocale(text)}</span>
                ),
            },
            {
                title: '',
                key: 'action',
                width: 100,
                render: (text: string, record: BackupData) => (
                    <>
                        {record.isDone && <Button
                            onClick={() => {
                                handleClickDownloadBackup(record);
                            }}
                            size={15}
                            color={colors.text}
                            background={colors.onBackground}
                            accent={colors.accent}
                        >
                            Baixar
                        </Button>}
                    </>
                ),
            },
        ];

        return (
            <TableGeneric<BackupData>
                sticky={true}
                size={'small'}
                tableColumns={tableColumn}
                tableDataSource={tableBackups.data}
                loading={loading}
                labelNoResults={'Nenhum backup realizado'}
                collapsedMenu={collapsed}
                defaultCurrentPage={1}
                totalRows={tableBackups.totalRows}
                page={tableBackups.page}
                pageSize={tableBackups.limit}
                rowSelection={null}
                onChange={(page) => getDataFromPage(page - 1)}
                onSelectedRow={() => {
                }}
            />
        )
    })
export default TableBackup;
